import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { connect } from "react-redux";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableRow } from "helpers/CustomMenu";
import { Delete } from "@mui/icons-material";
import { default as ReactSelect } from "react-select";

function StaffPositionComponent({ FetchDetails }) {
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [positions, setPositions] = React.useState([]);
  const [managers, setManagers] = React.useState([]);


  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "lineManager",
      label: "Line Manager",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const managers = list[dataIndex]?.positionManager || [];
          const managerNames = managers
            .map((manager) => manager.lineManager?.name)
            .filter(Boolean);

          return (
            <div className="flex flex-col">
              {managerNames.map((name, idx) => (
                <span key={idx} className="text-sm">
                  {name}
                </span>
              ))}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">

            <IconButton
              onClick={() => {
                setOpen(2);
                const obj = list.find((vx) => vx.id === v);
                // Map positionManager to positions
                const filterLineManagers = obj?.positionManager?.map((manager) => {
                  const matchedPosition = positions.find(
                    (position) => position.value === manager.line_manager
                  );
                  return matchedPosition
                    ? { assignee: matchedPosition.label, id: matchedPosition.value }
                    : null;
                }).filter(Boolean); // Remove null values

                setId(v);
                setValue0("name", obj?.name);
                setValue0("lineManager", filterLineManagers || []);
                setManagers(filterLineManagers || []);

              }}
            >
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Decorative SVG"
                className="mr-2 text-sm"
              />
            </IconButton>
            <IconButton onClick={() => { setId(v); setDeleteOpen(true); }}>
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Decorative SVG"
                className="mr-2 text-sm"
              />
            </IconButton>
          </div>
        ),
      },
    },
  ];
  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp?.status) {
      const positionList = resp?.data?.list?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPositions(positionList);
    }
  };
  const onSuccess = () => setCount((v) => v + 1);
  useEffect(() => {
    loadPositions().then();
  }, []);

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/staff-position/delete/${id}`}
      />
      <FormDialog
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={
          open === 1
            ? "/api/staff-position/create/"
            : `/api/staff-position/update/${id}`
        }
        title={open === 1 ? "Add New Position" : "Edit Position"}
        method={open === 1 ? "POST" : "POST"}

        fields={[
          {
            name: "name",
            label: "Name",
            value: value["name"],
            required: true,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "managers",
            label: "Line Manager",
            value: managers,
            col: 12,
            render: () => (
              <>
                <ReactSelect
                  options={positions}
                  onChange={(v) => {
                    setManagers([{ assignee: v?.label, id: v?.value }]);
                  }}
                  menuPortalTarget={document.body} // Ensures the dropdown is rendered in the body
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
                <TableContainer>
                  <Table size={"small"}>
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {managers?.map((item, index) => (
                        <StyledTableRow>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item?.assignee}</TableCell>
                          <TableCell>
                            <IconButton
                              color={"error"}
                              onClick={() => {
                                managers.splice(index, 1);
                                setManagers([...managers]);
                              }}
                            >
                              <Delete />
                            </IconButton>
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ),
          },
        ]}
      />
      <DatatableComponent
        onAddNew={() => setOpen(1)}
        search={false}
        viewColumns={false}
        searchfield={true}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={columns}
        url={`/api/staff-position/list?count=${count}`}
        title={"Positions List"}

      />
    </div>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffPositionComponent);
